import getScreenType from '@/utils/analytics/getScreenType';
import sendAiGenScreenActionAnalytics from '@/utils/analytics/sendAiGenScreenActionAnalytics';
import { AiGenScreenAction } from '@/types/analytics';

import type { AnalyticsSettings, ScreenType } from '@/types/analytics';

interface SendCreditsInfoAnalyticsParams {
  settings: AnalyticsSettings;
  /** Defaults to the current screen; pass it when the event outruns navigation. */
  screenType?: ScreenType;
}

/** Sends the `credits_info` action — the balance, plus the preset cost when a preset is open. */
const sendCreditsInfoAnalytics = ({
  settings,
  screenType = getScreenType(),
}: SendCreditsInfoAnalyticsParams) => {
  sendAiGenScreenActionAnalytics({
    action: AiGenScreenAction.CREDITS_INFO,
    screen_type: screenType,
    settings,
  });
};

export default sendCreditsInfoAnalytics;
